export type IMat2 = [
  a1: number,
  b1: number,
  a2: number,
  b2: number,
];

export class Mat2 {
  static create(): IMat2 {
    return [1, 0, 1, 0,];
  }

  static createRotation(angle: number): IMat2 {
    return [
      Math.cos(angle), -Math.sin(angle),
      Math.sin(angle), Math.cos(angle),
    ];
  }

  static inverse(matrix: IMat2): IMat2 | null {
    const [a1, b1, a2, b2] = matrix;
    const determinant = a1 * b2 - b1 * a2;

    if (determinant === 0) {
      return null; // The matrix is not invertible
    }

    const invDet = 1 / determinant;

    return [
      b2 * invDet,
      -b1 * invDet,
      -a2 * invDet,
      a1 * invDet
    ]
  }

  static IDENTITY: IMat2 = Mat2.create();
}